import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14","key":"svg-0"}],["path",{"d":"M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0","key":"svg-1"}]]

const IconSquareLetterC = createReactComponent('outline', 'square-letter-c', 'SquareLetterC', __iconNode);

export default IconSquareLetterC;